<script>
import { defineComponent } from 'vue';

const name = 'Card'
export default defineComponent({
    name,

    props: {
      addGrid: {
        type: Boolean,
        default: false
      }
    }
})

</script>

<template>
  <g-card :expansivel="false" :temCabecalho="false">
    <div :class="addGrid ? 'adicionaGrid' : ''">
      <slot></slot>
    </div>
  </g-card>
</template>

<style scoped>
.adicionaGrid {
  display: grid;
  grid-template-rows: max-content;
}

@media (min-width:1240px) { 
.adicionaGrid {
  padding-bottom: 25px;
}
}

@media (min-width:1800px) { 
.adicionaGrid {
  padding-bottom: 1.5rem;
}
}

</style>
